<template>
  <b-container v-if="page === 'LIST_TEMPLATE'" data-app fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title title-typography-color">
          <i aria-hidden="true" class="fa fa-file"></i>
          {{
            $t(
                    "public.views.Pages.Professional.Organization.Rating.titleTemplates"
            )
          }}
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button v-if="templates && templates.length !== 0" class="mr-2 btn-flat" style="right" variant="primary"
          @click="openDownload">Descargar
        </b-button>
        <b-button v-if="checkPermissionProfessional('ORGANIZATION_RATING', ['LIST'])" class="mr-2" style="right"
          variant="success" @click="viewCreateTemplate">{{
            $t("public.views.Pages.Professional.Organization.Rating.btnCreate")
          }}
        </b-button>
      </template>
      <template v-if="checkPermissionProfessional('ORGANIZATION_RATING', ['LIST'])" v-slot:body>
        <div v-if="templates && templates.length !== 0">
          <v-card-title>
            <v-text-field v-model="search" append-icon="mdi-magnify" hide-details single-line>
              <template slot="label">{{
                $t("public.views.Pages.Professional.Organization.Rating.search")
              }}
              </template>
            </v-text-field>
          </v-card-title>

          <v-data-table :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'fas fa-arrow-left',
            lastIcon: 'fas fa-arrow-right',
            prevIcon: 'fas fa-minus',
            nextIcon: 'fas fa-plus',
            'items-per-page-options': [10, 25, 50],
          }" :headers="headers" :items="templates" :items-per-page="10" :search="search" item-key="uuid">
            <template v-slot:item.active="{ item }">
              <b-badge v-if="item.selected" variant="success">
                {{ $t("generic.yes") }}
              </b-badge>
              <b-badge v-else variant="danger"> {{ $t("generic.no") }}</b-badge>
            </template>
            <template v-slot:item.uuid="{ item }">
              <div class="div-table-data">
                <button v-if="
                  checkPermissionProfessional('ORGANIZATION_RATING', ['LIST'])
                " id="btnUpdate" class="item" v-on:click="viewUpdateTemplate(item.uuid)">
                  <i class="ri-refresh-line"></i>
                </button>
                <b-popover v-if="
                  checkPermissionProfessional('ORGANIZATION_RATING', ['LIST'])
                " placement="botton" target="btnUpdate" triggers="hover focus">
                  <template #title>{{
                    $t(
                                      "public.views.Pages.Professional.Organization.Rating.organization.btnUpdate"
                    )
                  }}
                  </template>
                </b-popover>
                <button v-if="
                  checkPermissionProfessional('ORGANIZATION_RATING', ['LIST'])
                " id="btnClone" class="item" v-on:click="viewCloneTemplate(item.uuid)">
                  <i class="ri-file-copy-line"></i>
                </button>
                <b-popover v-if="
                  checkPermissionProfessional('ORGANIZATION_RATING', ['LIST'])
                " placement="botton" target="btnClone" triggers="hover focus">
                  <template #title>{{
                    $t(
                                      "public.views.Pages.Professional.Organization.Rating.organization.btnClone"
                    )
                  }}
                  </template>
                </b-popover>
                <button v-if="
                  checkPermissionProfessional('ORGANIZATION_RATING', ['LIST'])
                " id="btnDelete" class="item" v-on:click="viewDeleteTemplate(item.uuid)">
                  <i class="ri-delete-bin-line"></i>
                </button>
                <b-popover v-if="
                  checkPermissionProfessional('ORGANIZATION_RATING', ['LIST'])
                " placement="botton" target="btnDelete" triggers="hover focus">
                  <template #title>{{
                    $t(
                                      "public.views.Pages.Professional.Organization.Rating.organization.btnDelete"
                    )
                  }}
                  </template>
                </b-popover>

                <button v-if="
                  !item.selected &&
                  checkPermissionProfessional('ORGANIZATION_RATING', ['LIST'])
                " id="btnActive" class="item" v-on:click="templateActive(item.uuid)">
                  <i class="ri-play-circle-line"></i>
                </button>
                <b-popover v-if="
                  !item.selected &&
                  checkPermissionProfessional('ORGANIZATION_RATING', ['LIST'])
                " placement="botton" target="btnActive" triggers="hover focus">
                  <template #title>{{
                    $t(
                                      "public.views.Pages.Professional.Organization.Rating.organization.btnActive"
                    )
                  }}
                  </template>
                </b-popover>
              </div>
            </template>
          </v-data-table>
        </div>
        <div v-else>
          <b-alert show variant="primary">
            {{
              $t(
                        "public.views.Pages.Professional.Organization.Rating.organization.alert.empty"
              )
            }}
          </b-alert>
        </div>
      </template>
    </iq-card>
    <b-modal id="modal-download" centered @ok="download">
      <template #modal-title> Descargar valoraciones</template>
      <template #modal-ok>Descargar</template>
      <template #modal-cancel>{{
        $t(
              "public.views.Pages.Professional.Organization.Professionals.modalDelete.btnClose"
        )
      }}
      </template>
      <b-form-group label-for="dateStart">
        <template slot="label">Fecha inicio: *</template>
        <date-picker v-model="dateStartDownload" :format="myFormat" :formatter="momentFormat" class="w-100"
          type="date"></date-picker>
      </b-form-group>
      <b-form-group label-for="dateEnd">
        <template slot="label">Fecha fin: *</template>
        <date-picker v-model="dateEndDownload" :format="myFormat" :formatter="momentFormat" class="w-100"
          type="date"></date-picker>
      </b-form-group>
    </b-modal>
  </b-container>
  <b-container v-else data-app fluid>
    <div class="iq-card">
      <div class="iq-card-header d-flex justify-content-between">
        <div class="iq-header-title">
          <h4 class="card-title title-typography-color">
            <i class="fas fa-file"></i>
            {{
              $t(
                        "public.views.Pages.Professional.Organization.Rating.organization.titleInformation"
              )
            }}
          </h4>
        </div>
        <div class="iq-card-header-toolbar d-flex align-items-center">
          <b-button ref="btnShowNewContact" class="mr-2" style="right" variant="primary" @click="listTemplate">{{
            $t(
                      "public.views.Pages.Professional.Organization.Rating.organization.btnBack"
            )
          }}
          </b-button>
          <b-button v-if="checkPermissionProfessional('ORGANIZATION_RATING', ['LIST'])" ref="btnShowNewContact"
            class="mr-2" style="right" variant="success" @click="saveForm">
            <div v-if="action === 'CLONE'">
              {{
                $t(
                            "public.views.Pages.Professional.Organization.Rating.organization.btnCloneCreate"
                )
              }}
            </div>
            <div v-else>
              {{
                $t(
                            "public.views.Pages.Professional.Organization.Rating.organization.btnSave"
                )
              }}
            </div>
          </b-button>
        </div>
      </div>
      <div class="card-body iq-card-body">
        <b-form-group label-for="name">
          <template slot="label">{{ $t("rating.organization.name") }}: *
          </template>
          <b-form-input id="name" v-model="name" :disabled="disabled" type="text" v-bind:class="{
            'text-danger': isFormNameErrors,
            'is-invalid': isFormNameErrors,
          }" @blur="checkName(name)"></b-form-input>
          <ul v-if="isFormNameErrors">
            <li v-for="(error, index) in validatorStep1.getErrors('name')" v-bind:key="index"
              class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
      </div>
    </div>
    <div class="iq-card">
      <div class="iq-card-header d-flex justify-content-between">
        <div class="iq-header-title">
          <h4 class="card-title title-typography-color">
            <i class="fas fa-folder-plus"></i>
            {{
              $t(
                        "public.views.Pages.Professional.Organization.Rating.organization.title"
              )
            }}
          </h4>
        </div>
        <div class="iq-card-header-toolbar d-flex align-items-center">
          <b-button v-if="checkPermissionProfessional('ORGANIZATION_RATING', ['LIST'])" ref="btnShowNewContact"
            style="right" variant="success" @click="createTab">{{
              $t(
                        "public.views.Pages.Professional.Organization.Rating.organization.btnCreateTab"
              )
            }}
          </b-button>
        </div>
      </div>
      <div class="card-body iq-card-body">
        <tab-nav :tabs="true">
          <tab-nav-items v-for="(option, index) in tabs" :id="'tab-nav-' + index" :key="index" :active="index < 1"
            :ariaSelected="true" :href="'#tab-' + index" role="tab">
            <template v-slot:title>
              <b-form-input v-model="option.name"></b-form-input>
            </template>
          </tab-nav-items>
        </tab-nav>
        <tab-content>
          <tab-content-item v-for="(option, index) in tabs" :id="'tab-' + index" :key="index" :active="index < 1">
            <div class="test-survey-builder">
              <QuestionsView :questions="option.questionsList" :readOnly="false" />
              <div v-if="addQuestion">
                <SurveyBuilder :options="sampleQuestion" :tab="index" />
              </div>
              <div class="text-right">
                <b-button v-if="
                  checkPermissionProfessional('ORGANIZATION_RATING', ['LIST'])
                " variant="success" v-on:click="addNewQuestion()">
                  {{
  $t(
                  "public.views.Pages.Professional.Organization.Rating.organization.btnNewQuestion"
  )
                  }}
                </b-button>
              </div>
            </div>
          </tab-content-item>
        </tab-content>
      </div>
    </div>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import { xray } from "../../../../config/pluginInit";

import validator from "vue-m-validator";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

import Survey from "../../../../json/Survey";

import { saveAs } from "file-saver";

import moment from "moment";

import SurveyBuilder from "../../../../components/survey/SurveyBuilderRating";
import QuestionsView from "../../../../components/survey/QuestionsView";

import organizationService from "../../../../services/organization";
import professionalService from "../../../../services/professional";
import questionaryService from "../../../../services/questionary";
import ratingService from "../../../../services/rating";
import utilsService from "../../../../services/utils";

export default {
  name: "Rating",
  mounted() {
    xray.index();
    this.getAllTemplates();
    this.initComponetsTemplates();

    utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_RATINGS", info: "" });
  },
  computed: {
    isFormNameErrors() {
      let errors = this.validatorStep1.getErrors("name");
      return errors && errors.length > 0;
    },
  },
  methods: {
    download() {
      this.getAllRatingsByOrganization();
    },
    openDownload() {
      this.$bvModal.show("modal-download");
    },
    getAllRatingsByOrganization() {
      let data = {
        start: moment(this.dateStartDownload).format("YYYY-MM-DD"),
        end: moment(this.dateEndDownload).format("YYYY-MM-DD"),
      };

      this.$awn.asyncBlock(
        ratingService.getExcel(localStorage.getItem("organizationId"), data),
        (response) => {
          if (response) {

            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_RATINGS_EXCEL", info: "" });
            saveAs(response.data, "ratings.xlsx");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "ratingService.getExcel",
            module: "view-pages-professional-organization-rating",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: localStorage.getItem("organizationId"), data: data
            })
          });
        },
        " "
      );
    },
    checkPermissionProfessional(permission, permissionType) {
      return utilsService.checkPermissionProfessional(
        permission,
        permissionType
      );
    },
    //Get templates rating
    checkFormStep1() {
      this.checkName(this.name);
    },
    async initComponetsTemplates() {
      this.$root.$on("change-colums", (columns) => {
        this.numCol = columns;
      });
      this.$root.$on("add-update-question", (q, tab) => {
        this.updateQuestionsList(q, tab);
      });
    },
    updateQuestionsList(question, tab) {
      const questionIndex = this.tabs[tab].questionsList.findIndex(
        (x) => x.uuid === question.uuid
      );
      if (questionIndex >= 0) {
        this.tabs[tab].questionsList.splice(questionIndex, 1, question);
      } else {
        this.tabs[tab].questionsList.push(JSON.parse(JSON.stringify(question)));
      }
      this.addQuestion = false;
      this.$root.$emit("selected-question", null);
    },
    addNewQuestion() {
      this.sampleQuestion = JSON.parse(JSON.stringify(Survey));
      this.sampleQuestion.uuid = this.getGUID();
      this.addQuestion = true;
    },
    getGUID() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }

      return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4() + s4() + s4()}`;
    },
    getTemplate(uuid) {
      let self = this;

      this.$awn.asyncBlock(
        professionalService.findQuestionary(this.professional, uuid),
        (response) => {
          if (response) {
            self.uuid = response.data.uuid;
            self.selected =
              response.data.selected === null ? false : response.data.selected;
            self.name = response.data.name;
            self.numCol = response.data.numCol;
            self.tabs = response.data.tabs;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.findQuestionary",
            module: "view-pages-professional-organization-rating",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professional: this.professional, uuid: uuid
            })
          });
        },
        " "
      );
    },
    saveForm(evt) {
      evt.preventDefault();

      this.checkFormStep1();
      if (this.validatorStep1.errors.length === 0) {
        if (this.action === "CREATE") {
          this.createTemplate();
        }
        if (this.action === "UPDATE") {
          this.updateTemplate();
        }
        if (this.action === "CLONE") {
          this.cloneTemplate();
        }
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Rating.notification.error"
          ),
          text: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Rating.notification.descrErrorSave"
          ),
          type: "error",
        });
      }
    },
    createTemplate() {
      let self = this;

      let data = {
        uuid: this.uuid,
        numCol: this.numCol,
        selected: this.selected,
        name: this.name,
        professional: this.professional,
        template: true,
        tabs: this.tabs,
      };

      this.$awn.asyncBlock(
        questionaryService.saveTab(data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_RATINGS", info: "" });
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Rating.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Rating.notification.descSaveTemplate"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "questionaryService.saveTab",
            module: "view-pages-professional-organization-rating",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              data: data
            })
          });
        },
        " "
      );
    },
    templateActive(uuid) {
      let self = this;

      this.$awn.asyncBlock(
        organizationService.activateQuestionary(this.organizationId, uuid),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_RATINGS", info: "" });
            self.listTemplate();
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Rating.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Rating.notification.descActiveTemplate"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.activateQuestionary",
            module: "view-pages-professional-organization-rating",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: this.organizationId, uuid: uuid
            })
          });
        },
        " "
      );
    },
    deleteTemplate(uuid) {
      let self = this;

      this.$awn.asyncBlock(
        questionaryService.deleteTemplate(uuid),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "DELETE", module: "PROFESSIONAL_RATINGS", info: "" });
            self.listTemplate();
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Rating.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Rating.notification.descDeleteTemplate"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "questionaryService.deleteTemplate",
            module: "view-pages-professional-organization-rating",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              uuid: uuid
            })
          });
        },
        " "
      );
    },
    cloneTemplate() {
      let self = this;

      let data = {
        uuid: this.uuid,
        selected: this.selected,
        name: this.name,
        professional: this.professional,
        template: true,
        tabs: this.tabs,
      };

      this.$awn.asyncBlock(
        questionaryService.cloneTemplate(data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_RATINGS", info: "" });
            self.listTemplate();
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Rating.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Rating.notification.descCloneTemplate"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "questionaryService.cloneTemplate",
            module: "view-pages-professional-organization-rating",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              data: data
            })
          });
        },
        " "
      );
    },
    updateTemplate() {
      let self = this;

      let data = {
        uuid: this.uuid,
        name: this.name,
        selected: this.selected,
        professional: this.professional,
        template: true,
        tabs: this.tabs,
      };

      this.$awn.asyncBlock(
        questionaryService.updateTemplate(data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_RATINGS", info: "" });
            self.listTemplate();
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Rating.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Professional.Organization.Rating.notification.descRefreshTemplate"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "questionaryService.updateTemplate",
            module: "view-pages-professional-organization-rating",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              data: data
            })
          });
        },
        " "
      );
    },
    notFirst() {
      this.isFirstRun = false;
    },
    listTemplate() {
      this.getAllTemplates();
      this.page = "LIST_TEMPLATE";
    },
    cleanCreate() {
      this.name = "";
      this.uuid = "";
      this.professional = localStorage.getItem("userId");
      this.clearTabs();
      this.createTab();
    },
    viewCreateTemplate() {
      this.cleanCreate();
      this.action = "CREATE";
      this.page = "CREATE_TEMPLATE";
    },
    viewCloneTemplate(uuid) {
      this.getTemplate(uuid);
      this.cleanCreate();
      this.action = "CLONE";
      this.page = "CREATE_TEMPLATE";
    },
    viewUpdateTemplate(uuid) {
      this.getTemplate(uuid);
      this.cleanCreate();
      this.action = "UPDATE";
      this.page = "CREATE_TEMPLATE";
    },
    viewDeleteTemplate(uuid) {
      this.deleteTemplate(uuid);
      this.page = "LIST_TEMPLATE";
    },
    clearTabs() {
      this.tabs = [];
    },
    createTab() {
      let tab = {
        name: this.$i18n.t(
          "public.views.Pages.Professional.Organization.Rating.createdTab"
        ),
        questionsList: [],
      };

      this.tabs.push(tab);
    },
    async getAllTemplates() {
      let self = this;

      this.$awn.asyncBlock(
        professionalService.getAllTemplatesRating(this.professional),
        (response) => {
          if (response) {
            self.templates = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.getAllTemplatesRating(",
            module: "view-pages-professional-organization-rating",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professional: this.professional
            })
          });
        },
        " "
      );
    },
    //Validation form
    checkName(_name) {
      const NAME = _name.trim();
      const RULE_1 = {
        expression: !NAME || NAME === "",
        name: "name",
        msg: this.$i18n.t(
          "public.views.Pages.Professional.Organization.Rating.errors.erName"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    //Select organization
    backProfessionals() {
      this.showProfessional = true;
    },
    showRatingQuestion(ratingQuestions) {
      this.ratingQuestions = ratingQuestions;
      this.$bvModal.show("modal-rating-question");
    },
    getAllByProfessional(professionalId) {
      let self = this;

      this.professionalId = professionalId;

      this.$awn.asyncBlock(
        ratingService.getAllByProfessional(professionalId),
        (response) => {
          if (response) {
            self.showProfessional = false;
            self.ratings = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "ratingService.getAllByProfessional",
            module: "view-pages-professional-organization-rating",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              professionalId: professionalId
            })
          });
        },
        " "
      );
    },
    async getAllProfessionals() {
      let self = this;

      this.$awn.asyncBlock(
        organizationService.getAllProfessionals(),
        (response) => {
          if (response) {
            self.professionals = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.getAllProfessionals",
            module: "view-pages-professional-organization-rating",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null
          });
        },
        " "
      );
    },
  },
  data() {
    return {
      //Download
      dateStartDownload: moment().subtract(1, "months").toDate(),
      dateEndDownload: moment().toDate(),
      //Config date picker
      //vue2-data-picker
      myFormat: "DD/MM/YYYY",
      momentFormat: {
        //[optional] Date to String
        stringify: (date) => {
          return date ? moment(date).format("LL") : "";
        },
        //[optional]  String to Date
        parse: (value) => {
          return value ? moment(value, "LL").toDate() : null;
        },
        //[optional] getWeekNumber
        getWeek: (date) => {
          // a number
        },
      },

      organizationId: localStorage.getItem("organizationId"),
      professional: localStorage.getItem("userId"),
      //templates
      numCol: "12",
      disabled: false,
      tabs: [],
      name: "",
      selected: true,
      uuid: "",
      patient: "",
      addQuestion: false,
      validatorStep1: validator,
      page: "LIST_TEMPLATE",
      templates: [],
      headers: [
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Rating.headers.name"
          ),
          align: "start",
          value: "name",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Rating.headers.active"
          ),
          value: "active",
        },
        { text: "", value: "uuid" },
      ],
      //Tablas
      search: "",

      headersRating: [
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Rating.headers.date"
          ),
          align: "start",
          value: "date",
        },
        { text: "", value: "id" },
      ],
      ratings: [],
      //Rating question
      headersRatingQuestion: [
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Rating.modalRatingQuestion.headers.question"
          ),
          align: "start",
          value: "question",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Rating.modalRatingQuestion.headers.value"
          ),
          value: "value",
        },
      ],
      ratingQuestions: [],
      //Profesionals
      showProfessional: true,
      professionalId: "",
      headersProfessional: [
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Rating.professional.headers.name"
          ),
          align: "start",
          value: "name",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Rating.professional.headers.lastname"
          ),
          value: "lastname",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Rating.professional.headers.document"
          ),
          value: "document",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Professional.Organization.Rating.professional.headers.email"
          ),
          value: "email",
        },
        { text: "", value: "id" },
      ],
      professionals: [],
    };
  },
  components: {
    SurveyBuilder,
    QuestionsView,
    "vue-dropzone": vue2Dropzone,
    DatePicker,
  },
};
</script>
